export function lookupBankV2(send) {
  return (query, ...args) =>
    send(
      {
        path: '/v2/banklookup/bank',
        pathParameters: {},
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
